/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (cass)
  {
    this.cass = cass;
  }


  getType ()
  {
    return this.cass.type;
  }


  getVariant ()
  {
    return this.cass.variant;
  }


  getID ()
  {
    return this.cass.zone;
  }


  getUser ()
  {
    return this.cass.user;
  }


  getPlanet ()
  {
    return this.cass.planet;
  }


  getCoords ()
  {
    return this.cass.coords;
  }


  getLocation ()
  {
    return this.cass.location;
  }


  getStatus ()
  {
    return this.cass.status;
  }


  getCreateDate ()
  {
    return this.cass.create_date;
  }

  getUpdateDate ()
  {
    return this.cass.update_date;
  }


  getArgs ()
  {
    return this.cass.args;
  }


};
